<template>
  <v-col
      :order="order"
      :class="classFlex"
      :cols="cols"
      :md="md"
      :lg="lg">
    <v-icon
        v-if="icon"
        class="mr-1"
        :color="iconColor"
        @click="iconClick">
      {{ icon }}
    </v-icon>
    <label
        v-if="label"
        :class="classLabel"
        font-weight-bold>
      {{ label + separator }}
    </label>
    <br v-if="multiline">
    <span
        v-if="!to"
        :class="`${classValue} ${icon ? 'ml-7' : ''}`"
        @click="click">
      {{ displayValue }}
    </span>
    <router-link
        v-else
        :to="{ path: to }">
      {{ displayValue }}
    </router-link>
  </v-col>
</template>

<style scoped>

</style>

<script>
  export default {
    props: {
      display: [String, Number],
      icon: {
        type: String
      },
      iconColor: {
        type: String
      },
      label: {
        type: String
      },
      cols: {
        type: [String, Number],
        default: '12'
      },
      order: {
        type: [String, Number],
        default: null
      },
      md: {
        type: [String, Number],
        default: null
      },
      lg: {
        type: [String, Number],
        default: null
      },
      classFlex: {
        type: String,
        default: 'py-1 my-1'
      },
      classLabel: {
        type: String,
        default: 'v-label v-label--active font-weight-bold textcolor--text '
      },
      classValue: {
        type: String,
        default: 'v-label v-label--active textcolor--text'
      },
      separator: {
        type: String,
        default: ': '
      },
      multiline: {
        type: Boolean,
        default: false
      },
      to: {
        type: String
      },
      noData: {
        type: String,
        default: 'Не указано'
      }
    },
    computed: {
      displayValue () {
        return this.display || this.$t(this.noData)
      }
    },
    methods: {
      click: function () {
        this.$emit('click')
      },
      iconClick: function () {
        this.$emit('click:prepend-icon')
      }
    }
  }
</script>
